import {FC, lazy, Suspense} from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import {HomePage} from '../pages/home/HomePage'
import {Covid} from '../pages/home/ge/virology/covid-19-positivity-rate/Covid'
import {Influenza} from '../pages/home/ge/virology/influenza-positivity-rate/Influenza'
import {RespiratorySyndroms} from '../pages/home/ge/social-media/RespiratorySyndroms'
import {PharmacySales} from '../pages/home/ge/ambulatory-care/pharmacy-sales/PharmacySales'
import {DoctorVisits} from '../pages/home/ge/ambulatory-care/doctor-visits-for-respiratory-syndroms/DoctorVisits'
import {HospitalAdmissions} from '../pages/home/ge/hospital/admissions-for-resp-syndroms/HospitalAdmissions'
import {DeathsForRespiratory} from '../pages/home/ge/hospital/deaths-for-respiratory-syndroms/DeathsForRespiratory'
const PublicGeRoutes = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='/' element={<HomePage />} />
        {/* Pages */}
        <Route path='dashboard' element={<HomePage />} />

        <Route
          path='google-trends'
          element={
            <SuspensedView>
              <RespiratorySyndroms />
            </SuspensedView>
          }
        />
        <Route
          path='pharmacy-sales'
          element={
            <SuspensedView>
              <PharmacySales />
            </SuspensedView>
          }
        />
        <Route
          path='doctor-visits'
          element={
            <SuspensedView>
              <DoctorVisits />
            </SuspensedView>
          }
        />
        <Route
          path='hospital-adminssions'
          element={
            <SuspensedView>
              <HospitalAdmissions />
            </SuspensedView>
          }
        />
        <Route
          path='deaths-for-covid'
          element={
            <SuspensedView>
              <DeathsForRespiratory />
            </SuspensedView>
          }
        />
        <Route
          path='viruses-positivity-rate'
          element={
            <SuspensedView>
              <Influenza />
            </SuspensedView>
          }
        />
        <Route
          path='viral-load-in-wastewater'
          element={
            <SuspensedView>
              <Covid />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PublicGeRoutes}
